import { ZdateTime } from '../common.zod';
import { z } from 'zod';

// TechlogAircraft schema
export const ZTechlogAircraft = z.object({
  id: z.string().describe('Unique identifier for the aircraft'),
  operatorId: z
    .string()
    .describe('ID of the operator who owns/operates this aircraft'),
  aircraftTypeId: z
    .string()
    .describe('ID of the aircraft type/model reference'),
  serialNumber: z
    .string()
    .describe('Manufacturer serial number (MSN) of the aircraft'),
  registration: z
    .string()
    .describe(
      'Registration marking of the aircraft (e.g., "N123AB" or "G-ABCD")',
    ),
  year: z.number().describe('Year of manufacture for the aircraft'),
  fuelUnit: z
    .string()
    .describe('Unit of measurement for fuel (e.g., "kg", "lb", "l")'),
  oilUnit: z
    .string()
    .describe('Unit of measurement for oil (e.g., "ml", "qt")'),
  maxFuelValue: z
    .number()
    .describe('Maximum fuel capacity of the aircraft in the specified unit'),
  monthlyCycles: z.number().describe('Number of cycles completed this month'),
  monthlyFlightSeconds: z
    .number()
    .describe('Total flight time in seconds for the current month'),
  monthlyApuSeconds: z
    .number()
    .describe(
      'Total APU (Auxiliary Power Unit) run time in seconds for the current month',
    ),
  maintenanceType: z
    .string()
    .describe('Type of maintenance tracking (e.g., "hours")'),
  apuMode: z
    .string()
    .describe('Mode of the APU (e.g., "notInstalled" if aircraft has no APU)'),
  flightStatus: z
    .string()
    .describe('Current flight status of the aircraft (e.g., "inFlight")'),
  createdAt: ZdateTime.describe(
    'Timestamp when this aircraft record was created',
  ),
  updatedAt: ZdateTime.describe(
    'Timestamp when this aircraft record was last updated',
  ),
});

// TechlogAircraftType schema
export const ZTechlogAircraftType = z.object({
  id: z.string().describe('Unique identifier for the aircraft type'),
  engineCount: z.string().describe('Number of engines on the aircraft'),
  engineType: z
    .enum(['piston', 'jet', 'turboprop', 'electric', 'rocket'])
    .describe(
      'Type of engines on the aircraft (e.g., "jet" for turbofan/turbojet engines)',
    ),
  weightCategory: z
    .enum(['light', 'light_medium', 'medium', 'heavy'])
    .describe('Aircraft weight category for ATC and operational purposes'),
});

// TechlogAircraftWithType schema
export const ZTechlogAircraftWithType = ZTechlogAircraft.extend({
  aircraftType: ZTechlogAircraftType.optional().describe(
    'Details about the aircraft type/model',
  ),
});
